import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";
import headLogo from "../../Assets/images/dignity_logo_svg.png"
import { useTranslation } from "react-i18next";

const HeaderBefore = () => {
  const [isSticky, setIsSticky] = useState(false);
  const{t} =  useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 991) {
        if (window.scrollY > 300) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div id="header" className={`logo-back ${isSticky ? "sticky" : ""}`}>
        <Container>
          <Navbar expand="lg">
            <Container fluid>
              <Link className="brand-logo">
                <img src={headLogo} alt="" width={100} />
              </Link>
            </Container>
          </Navbar>
        </Container>
      </div>
    </>
  );
};

export default HeaderBefore;
